import type { TipoMoneda } from '../services/tipoMonedaService';

export const LABEL_TIPO_MONEDA_PESOS = 'PESOS';

export function getCodigoTipoMoneda(t: TipoMoneda): number {
  return Number(t.codigoMoneda ?? (t as { tipoMoneda?: number }).tipoMoneda ?? 0);
}

/** Código 0 → PESOS; otro código → descripción/símbolo de la tabla TipoMoneda. */
export function getTipoMonedaDescripcion(
  codigo: number | null | undefined,
  tiposMoneda: TipoMoneda[] = []
): string {
  if (codigo == null) return '';
  const n = Number(codigo);
  if (Number.isNaN(n)) return '';
  if (n === 0) return LABEL_TIPO_MONEDA_PESOS;

  const found = tiposMoneda.find((t) => getCodigoTipoMoneda(t) === n);
  if (found) {
    const desc = found.descripcion?.trim();
    if (desc) return desc;
    const sim = found.simbolo?.trim();
    if (sim) return sim;
  }
  return String(n);
}
